import React from "react";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import SportsSoccerRoundedIcon from "@mui/icons-material/SportsSoccerRounded";
import AssistantPhotoRoundedIcon from "@mui/icons-material/AssistantPhotoRounded";
import StyleRoundedIcon from "@mui/icons-material/StyleRounded";
import TeamCrest from "../../components/ui/TeamCrest";
import tokens from "../../theme/tokens";

export const cardColor = { amarelo: "#EAB308", azul: tokens.color.info, vermelho: tokens.color.danger };

const EventList = ({ icon, title, items }) =>
  items.length > 0 && (
    <Box sx={{ minWidth: 0 }}>
      <Stack direction="row" spacing={0.75} alignItems="center" sx={{ mb: 0.5, color: "text.secondary" }}>
        {icon}
        <Typography variant="caption" fontWeight={700} sx={{ textTransform: "uppercase", letterSpacing: "0.04em" }}>{title}</Typography>
      </Stack>
      {items.map((item, index) => (
        <Typography key={index} variant="body2" noWrap>{item}</Typography>
      ))}
    </Box>
  );

// Placar de um jogo do torneio com gols, assistências e cartões.
const GameCard = ({ jogo, onClick, actions }) => {
  const fase = jogo.isFinal ? "Final" : jogo.isSemifinal ? "Semifinal" : null;
  const data = jogo.dataJogo ? new Date(jogo.dataJogo).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : null;

  return (
    <Card sx={{ cursor: onClick ? "pointer" : "default", transition: "box-shadow .2s", "&:hover": onClick ? { boxShadow: tokens.shadow.md } : undefined }} onClick={onClick}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 2, pt: 1.5 }}>
        <Typography variant="caption" color="text.secondary">{data}</Typography>
        {fase && <Chip size="small" color={jogo.isFinal ? "primary" : "default"} label={fase} />}
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} sx={{ px: 2, py: 2 }}>
        <Stack alignItems="center" spacing={0.75} sx={{ flex: 1, minWidth: 0, textAlign: "center" }}>
          <TeamCrest name={jogo.timeA?.nome} size={52} />
          <Typography fontWeight={700} noWrap sx={{ maxWidth: "100%" }}>{jogo.timeA?.nome}</Typography>
          {jogo.goleiroTimeA && <Typography variant="caption" color="text.secondary">GK {jogo.goleiroTimeA}</Typography>}
        </Stack>
        <Typography sx={{ fontFamily: tokens.font.display, fontWeight: 700, fontSize: "2.4rem", px: 2, whiteSpace: "nowrap" }}>
          {jogo.placar?.timeA ?? 0} <Box component="span" sx={{ color: "text.disabled" }}>×</Box> {jogo.placar?.timeB ?? 0}
        </Typography>
        <Stack alignItems="center" spacing={0.75} sx={{ flex: 1, minWidth: 0, textAlign: "center" }}>
          <TeamCrest name={jogo.timeB?.nome} size={52} />
          <Typography fontWeight={700} noWrap sx={{ maxWidth: "100%" }}>{jogo.timeB?.nome}</Typography>
          {jogo.goleiroTimeB && <Typography variant="caption" color="text.secondary">GK {jogo.goleiroTimeB}</Typography>}
        </Stack>
      </Stack>
      {(jogo.gols.length > 0 || jogo.assistencias.length > 0 || jogo.cartoes.length > 0) && (
        <>
          <Divider />
          <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" }, gap: 2, px: 2, py: 1.5 }}>
            <EventList icon={<SportsSoccerRoundedIcon sx={{ fontSize: 16 }} />} title="Gols" items={jogo.gols.map((gol) => `${gol.jogador?.nome} (${gol.quantidade})`)} />
            <EventList icon={<AssistantPhotoRoundedIcon sx={{ fontSize: 16 }} />} title="Assistências" items={jogo.assistencias.map((a) => `${a.jogador?.nome} (${a.quantidade})`)} />
            <EventList
              icon={<StyleRoundedIcon sx={{ fontSize: 16 }} />}
              title="Cartões"
              items={jogo.cartoes.map((cartao) => (
                <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
                  <Box component="span" sx={{ width: 10, height: 14, borderRadius: 0.5, bgcolor: cardColor[cartao.tipo] }} />
                  {cartao.jogador?.nome}
                </Box>
              ))}
            />
          </Box>
        </>
      )}
      {actions && (
        <>
          <Divider />
          <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ px: 2, py: 1 }} onClick={(e) => e.stopPropagation()}>
            {actions}
          </Stack>
        </>
      )}
    </Card>
  );
};

export default GameCard;
